module.exports = __webpack_public_path__ + "static/media/Medium.11eda9ba.svg";